<template>
  <div
    class="relative color-black bg-white w-full card-p card-rounded shadow-card pointer-events-auto flex flex-col items-start"
    :class="{
      'clamp-max-w-100-200 ': blok.component === 'ErrorSearchNoResults',
      'bg-opacity-20% text-[--section-text-color]':
        blok.component === 'ErrorNoResults',
    }"
  >
    <div class="absolute right-0 bottom-0">
      <ElementMedia
        v-if="blok.media?.length"
        :bloks="blok.media"
        ratio="orig"
        :sizes="[
          { vw: 25, bpMin: 'tp' },
          { vw: 33, bpMin: '0' },
        ]"
        class="clamp-w-22-35"
      />
    </div>
    <ElementTexts
      :bloks="blok.texts"
      textPosition="left"
      class="text-max-w-card"
      :class="{ 'clamp-max-w-50-290': blok.component === 'ErrorNoResults' }"
    />
    <AButton
      v-if="blok.clearSearchAndFiltersCta"
      icon="xmark"
      :text="blok.clearSearchAndFiltersCta"
      variant="secondary"
      @click="() => emit('clear')"
      class="clamp-mt-8-12"
    />
  </div>
</template>

<script setup lang="ts">
import {
  ErrorSearchNoResultsStoryblok,
  ErrorNoResultsStoryblok,
} from '@/types';

const props = defineProps<{
  blok: ErrorSearchNoResultsStoryblok | ErrorNoResultsStoryblok;
}>();
const emit = defineEmits(['clear']);
</script>

<style scoped></style>
